import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowUp"><Path d="M12 20.5V4" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 10L12 3.5L18.5 10" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowUp;
